/**
 * OrderConfirmation.js — Final "Order Placed!" card (kind
 * "order-confirmation"), Lightning Rock Winery variant.
 *
 * Parity with old showOrderConfirmation (RedConcierge/static/javascript/main.js):
 * checkmark + "Order Placed!" + "You will receive your wines soon. Your
 * order id is <id>." Fired after a successful Commerce7 charge; the
 * checkout orchestrator clears the cart alongside showing this.
 *
 * message.data: { orderId }
 */

export default class OrderConfirmation {
  render(message) {
    const orderId = message?.data?.orderId || "";

    const row = document.createElement("div");
    row.className = "ws-bot-row";

    const avatar = document.createElement("div");
    avatar.className = "ws-avatar ws-bot-avatar";
    row.appendChild(avatar);

    const wrap = document.createElement("div");
    wrap.className = "ws-bubble-wrap";

    const bubble = document.createElement("div");
    bubble.className = "ws-bot-bubble";
    bubble.style.display = "flex";
    bubble.style.flexDirection = "column";
    bubble.style.gap = "6px";

    const title = document.createElement("div");
    title.style.fontWeight = "600";
    title.style.display = "flex";
    title.style.alignItems = "center";
    title.style.gap = "6px";
    title.textContent = "✅ Order Placed!";
    bubble.appendChild(title);

    const body = document.createElement("div");
    body.textContent = "You will receive your wines soon.";
    if (orderId) {
      body.appendChild(document.createTextNode(" Your order id is "));
      const id = document.createElement("strong");
      id.textContent = orderId;
      body.appendChild(id);
      body.appendChild(document.createTextNode("."));
    }
    bubble.appendChild(body);

    wrap.appendChild(bubble);
    row.appendChild(wrap);
    return row;
  }
}
